import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'carbon-react/lib/components/button';

import { ModalView } from '@futrli/ui-components';

interface ImportPageWrapperProps {
  children?: ReactNode;
  forecastName?: string;
  onCancel?: () => void;
}

export const ImportPageWrapper = ({ children, forecastName, onCancel }: ImportPageWrapperProps) => {
  return (
    <>
      <ModalView
        title={
          <FormattedMessage
            id="predict.templates_for_value"
            defaultMessage="Templates for {forecastName}"
            values={{ forecastName }}
          />
        }
        headerStyle="fixed"
        style={{ top: 81 }}
        headerButtons={
          <Button onClick={onCancel}>
            <FormattedMessage id="predict.cancel_exit" defaultMessage="Cancel & exit" />
          </Button>
        }
      >
        {children}
      </ModalView>
    </>
  );
};
